module.exports = __webpack_public_path__ + "img/フォロバ_0226030600.559b0402.png";